import React from "react";
import {TemplateFileRepository} from "../../../repository";
import {TemplateFile} from "../../../model";
import {EntityReadTemplate} from "../../../component/template/EntityReadTemplate";
import {Downloader} from "../../../component/Downloader";
import {Attribute} from "../../../component/Attribute";

export const ReadTemplateFile = () => {

    return (
        <EntityReadTemplate<TemplateFile>
            repository={new TemplateFileRepository()}
            title={{
                page: `Document`,
                schema: `$0`,
                params: [`name`]
            }}
            attributes={[
                { label: `Nom`, key: 'name' },
                { label: `Description`, key: 'description' },
                { label: `Version`, key: 'version' },
                { label: `Répertoire`, key: 'directory.name' },
                { label: `Permission`, key: 'permission' },
            ]}
        >
            {
                (data: TemplateFile) => (
                    <Attribute label={'Fichier'} value={<Downloader id={data.id} type={'template'} filename={data.name}/>}/>
                )
            }
        </EntityReadTemplate>
    )
}